import React, { Component } from "react";
import { Redirect } from "react-router";
import { Link } from "react-router-dom";
import "./CarRegistration.scss";
import sendEventoGTM from "../../utils/tags";

export default class CarRegistration extends Component {
  constructor() {
    super();
    this.state = {
      plate: "",
    };
  }

  scrollToTop = () => {
    if (window.innerWidth <= 425) {
      let elmnt = document.getElementById("introduce-matricula");
      elmnt && elmnt.scrollIntoView();
    }
  };

  componentDidMount() {
    this.scrollToTop();
    this.props.setAppBarState(2, 1, 0, 0);
    // Dealer Selected
    sendEventoGTM(
      "3-dealer-selected",
      "0"
    );
  }

  handleChange = e => {
    const { value } = e.target;
    this.setState({ ...this.state, plate: value.replace(/\s/g, "") });
  };

  setPlate = () => {
    this.props.getCarByRegistration(this.state.plate);
    // Model Selected/ Matrícula
    sendEventoGTM(
      "4-license-plate-submit",
      "0"
    );
  };

  setPlatePressEnter(e) {
    if (e.keyCode === 13) {
      this.props.getCarByRegistration(this.state.plate);
      // Model Selected/ Matrícula
      sendEventoGTM(
        "4-model-search",
        "0"  
      );
    }
  }

  plateValidator(plate) {
    if (plate.length === 7) {
      return (
        plate.toUpperCase().match(/^([A-Z]{1,2})?\d{4}([A-Z]{2,3})$/) != null
      );
    }
  }

  render() {
    if (this.props.redirectToInit) {
      return <Redirect to="/" />;
    }
    if (this.props.redirectToCalculator) {
      return <Redirect to="/calculator" />;
    }
    let activeButtonClass = "disabled";
    let activeButtonLink = false;
    if (this.plateValidator(this.state.plate)) {
      activeButtonClass = "";
      activeButtonLink = true;
      //this.setPlate;
    }

    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="title">
              <h3 id="introduce-matricula" className="small-title text-center">
                Introduce la matrícula o escoge un tipo de vehículo
              </h3>
            </div>
            <div className="pane-list-container ">
              <div className="pane-list-row">
                <div className="pane pane-with-button pane-car-reg-l">
                  <div className="img-container">
                    <img src="./images/matricula.png" alt="icon-matricula" />
                  </div>
                  <div className="text matricula-tipo">
                    Introduce la matrícula del vehículo
                  </div>
                  <div className="input-container">
                    <input
                      type="text"
                      placeholder="Por ej.: 0987 KSX"
                      onChange={e => this.handleChange(e)}
                      onKeyDown={e => this.setPlatePressEnter(e)}
                    />

                    {this.props.loading ? (
                      <div className="loader-plate-container">
                        <img
                          className="loader-plate"
                          src="./images/spinner.gif"
                          alt="loader"
                        />
                      </div>
                    ) : this.props.notFoundPlateMsg ? (
                      <div>
                        <p className="not-found-msg">
                          Los datos del vehículo no se han
                          <br />
                          encontrado. Puedes intentarlo de nuevo
                          <br />o{" "}
                          <Link to="/modelSelector">
                            continuar sin indicar la matrícula.
                          </Link>
                        </p>
                      </div>
                    ) : null}
                  </div>
                  <div className="button-container" style={{ display: "flex", alignItems: "center", justifyContent: "center", textDecoration: "none" }}>
                    {/* <button
                      onClick={() => {
                        activeButtonLink && this.setPlate();
                      }}
                      className={`mobileBtn mm-button mm-block mm-rounded mm-red ${activeButtonClass}`}
                    >
                      Enviar
                    </button> */}
                    <button class="button_mostrar_mas btn-descubrir" style={{ marginTop: 20 }} type="button" onClick={() => { activeButtonLink && this.setPlate() }}>
                      <span class="btn-vehiculos" style={{ marginLeft: 40 }}>
                        ENVIAR
                      </span>
                      <span class="linea-boton"></span>
                    </button>
                  </div>
                </div>

                <div className="pane pane-no-plate pane-with-button pane-car-reg-r">
                  <div className="img-container">
                    <img src="./images/car.png" alt="icon-car" />
                  </div>
                  <div className="text matricula-tipo">No conozco la matrícula</div>
                  <div className="button-container">
                    <Link to="/modelSelector" style={{ display: "flex", alignItems: "center", justifyContent: "center", textDecoration: "none" }}>
                      {/* <button
                        type="button"
                        className="mm-button mm-block mm-rounded mm-red button-no-plate"
                      >
                        Continuar sin matrícula
                      </button> */}
                      <button class="button_mostrar_mas btn-descubrir" type="button">
                        <span class="btn-vehiculos" style={{ marginLeft: 5 }}>
                          {/* <a href="https://www.lexusauto.es/seminuevos-select/" target="_blank" rel="noopener noreferrer"> */}
                          {/* Continuar sin matrícula */}
                          CONTINUAR SIN MATRÍCULA
                          {/* </a> */}
                        </span>
                        <span class="linea-boton"></span>
                      </button>

                      {/* <button _ngcontent-c6="" class="btn button_mostrar_todos" type="submit" tabindex="0">
                        <span _ngcontent-c6="" class="btn-vehiculos">
                          <span _ngcontent-c6="" class="btn-text">Continuar sin matrícula</span>
                        </span>
                        <div _ngcontent-c6="" class="linea-boton"></div>
                      </button> */}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
